import { FormControl } from '@angular/forms';
import { ETicketType } from '../ticket/ticket.enums';

export interface ISearchSortimentForm {
  search: FormControl<string | null>;
  sortedBy: FormControl<string | null>;
  filterType: FormControl<ETicketType[]>;
  filterStatus: FormControl<ETicketStatusFilter | ''>;
}

export interface TicketSortOption {
  label: string;
  value: TicketSortValue;
}

export type TicketSortValue =
  | 'name-ascending'
  | 'name-descending'
  | 'type-ascending'
  | 'type-descending';

export enum ETicketStatusFilter {
  Active = 'active',
  Inactive = 'inactive',
}

export interface TicketStatusOption {
  name: string;
  value: ETicketStatusFilter;
}

export const ticketTypes: {
  name: string;
  value: ETicketType;
}[] = [
  { name: 'Festpreis', value: ETicketType.Direct },
  { name: 'Abo', value: ETicketType.Subscription },
  { name: 'Relation', value: ETicketType.Relation },
];

export const ticketStatuses: TicketStatusOption[] = [
  { name: 'Aktiv', value: ETicketStatusFilter.Active },
  { name: 'Inaktiv', value: ETicketStatusFilter.Inactive },
];
